export const ReferralStoreTitle = ({size = 38}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 38 38"
    fill="none"
  >
    <g filter="url(#filter0_n_19334_887)">
      <rect width="38" height="38" rx="19" fill="black" />
      <rect
        x="0.25"
        y="0.25"
        width="37.5"
        height="37.5"
        rx="18.75"
        stroke="white"
        stroke-width="0.5"
      />
    </g>
    <g filter="url(#filter1_n_19334_887)">
      <rect
        x="4.38477"
        y="4.38452"
        width="29.2308"
        height="29.2308"
        rx="14.6154"
        fill="black"
      />
      <rect
        x="4.88477"
        y="4.88452"
        width="28.2308"
        height="28.2308"
        rx="14.1154"
        stroke="#7515ED"
      />
    </g>
    <g filter="url(#filter2_d_19334_887)">
      <path
        d="M22.1149 13.962C22.3317 14.6596 22.4466 15.3574 22.4484 16.037C22.4502 16.7552 22.3485 17.4533 22.1336 18.1423C21.9203 18.8203 21.6356 19.3731 21.2745 19.7861C21.6377 20.1982 21.9252 20.7484 22.1419 21.4277C22.3603 22.1161 22.4655 22.8139 22.4673 23.5322C22.4691 24.2098 22.3593 24.9098 22.1444 25.608C21.9296 26.3155 21.6465 26.8775 21.2935 27.2813L21.3893 27.458L23.9872 27.4545C24.3579 27.0305 24.6475 26.4666 24.8672 25.772C25.0853 25.0664 25.1902 24.3517 25.1883 23.6169C25.1866 22.9227 25.07 22.2083 24.8467 21.4941C24.6234 20.7688 24.3309 20.1964 23.9678 19.7844C24.3385 19.3604 24.6281 18.7964 24.8478 18.1019C25.0659 17.3944 25.1708 16.6798 25.1689 15.945C25.1671 15.2507 25.0505 14.5363 24.8273 13.8221C24.6039 13.0968 24.3115 12.5245 23.9483 12.1124L21.3504 12.1159L21.2555 12.2928C21.6106 12.6956 21.8965 13.2551 22.1149 13.962Z"
        fill="white"
      />
      <path
        d="M18.0733 13.9687C18.2917 14.6663 18.405 15.3641 18.4067 16.0437C18.4085 16.7619 18.3068 17.46 18.0919 18.149C17.8787 18.827 17.5939 19.3798 17.2328 19.7928C17.596 20.2049 17.8835 20.7551 18.1003 21.4344C18.3186 22.1228 18.4239 22.8206 18.4257 23.5389C18.4274 24.2166 18.3176 24.9165 18.1028 25.6147C17.8879 26.3222 17.6048 26.8842 17.2518 27.288L17.3476 27.4647L19.9472 27.4612C20.3179 27.0372 20.6075 26.4733 20.8272 25.7787C21.0469 25.0731 21.1501 24.3584 21.1483 23.6236C21.1465 22.9294 21.0299 22.215 20.8066 21.5008C20.5833 20.7755 20.2909 20.2031 19.9277 19.7911C20.2985 19.3671 20.588 18.8032 20.8078 18.1086C21.0274 17.403 21.1307 16.6883 21.1289 15.9535C21.1271 15.2593 21.0105 14.5449 20.7872 13.8306C20.5639 13.1054 20.2715 12.533 19.9083 12.121L17.3104 12.1244L17.2155 12.3014C17.5705 12.7023 17.8565 13.2618 18.0733 13.9687Z"
        fill="white"
      />
      <path
        d="M13.8871 27.2891L13.983 27.4658L16.5808 27.4623L16.542 12.1221L13.9441 12.1255L13.8492 12.3024L13.8871 27.2891Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_n_19334_887"
        x="0"
        y="0"
        width="38"
        height="38"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feTurbulence
          type="fractalNoise"
          baseFrequency="0.25 0.25"
          stitchTiles="stitch"
          numOctaves="3"
          result="noise"
          seed="7375"
        />
        <feColorMatrix in="noise" type="luminanceToAlpha" result="alphaNoise" />
        <feComponentTransfer in="alphaNoise" result="coloredNoise1">
          <feFuncA
            type="discrete"
            tableValues="1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
          />
        </feComponentTransfer>
        <feComposite
          operator="in"
          in2="shape"
          in="coloredNoise1"
          result="noise1Clipped"
        />
        <feFlood flood-color="rgba(0, 0, 0, 0.25)" result="color1Flood" />
        <feComposite
          operator="in"
          in2="noise1Clipped"
          in="color1Flood"
          result="color1"
        />
        <feMerge result="effect1_noise_19334_887">
          <feMergeNode in="shape" />
          <feMergeNode in="color1" />
        </feMerge>
      </filter>
      <filter
        id="filter1_n_19334_887"
        x="4.38477"
        y="4.38452"
        width="29.2308"
        height="29.2307"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feTurbulence
          type="fractalNoise"
          baseFrequency="0.25 0.25"
          stitchTiles="stitch"
          numOctaves="3"
          result="noise"
          seed="7963"
        />
        <feColorMatrix in="noise" type="luminanceToAlpha" result="alphaNoise" />
        <feComponentTransfer in="alphaNoise" result="coloredNoise1">
          <feFuncA
            type="discrete"
            tableValues="1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
          />
        </feComponentTransfer>
        <feComposite
          operator="in"
          in2="shape"
          in="coloredNoise1"
          result="noise1Clipped"
        />
        <feFlood flood-color="rgba(0, 0, 0, 0.25)" result="color1Flood" />
        <feComposite
          operator="in"
          in2="noise1Clipped"
          in="color1Flood"
          result="color1"
        />
        <feMerge result="effect1_noise_19334_887">
          <feMergeNode in="shape" />
          <feMergeNode in="color1" />
        </feMerge>
      </filter>
      <filter
        id="filter2_d_19334_887"
        x="9.84917"
        y="12.1125"
        width="19.3392"
        height="23.3533"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_19334_887"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_19334_887"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);